import { usePermissions } from '@contexts/permissions-provider';

/**
 * Hook to check if user has a specific permission
 * Convenience wrapper around usePermissions().hasPermission()
 *
 * @param permissionName - The name of the permission to check (e.g., 'view_dashboard')
 * @returns boolean indicating if user has the permission
 * @throws Error if used outside PermissionsProvider
 *
 * @example
 * const canViewDashboard = useHasPermission('view_dashboard');
 * if (canViewDashboard) {
 *   return <Dashboard />;
 * }
 */
export function useHasPermission(permissionName: string): boolean {
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading) {
    return false;
  }

  return hasPermission(permissionName);
}
